import React, { Fragment } from 'react';
import { Row, Col, Table, Badge } from 'reactstrap';
import { formattedDateOnly } from '../../../../../utilities/formatedDate';


const JourneyDetails = ({ data }) => {

    return (
        <Fragment>
            <Row className='mt-4'>
                <Col sm="12" >
                    <Table>
                        <tbody>
                            <tr>
                                <th>Quotation Number</th>
                                <td className="text-right pr-5">
                                    {data?.quotation_number ? data?.quotation_number : '-'}
                                </td>
                            </tr>
                            <tr>
                                <th>Business Central Sync</th>
                                <td className="text-right pr-5">
                                    {data?.bcFlag ? (<>
                                        <Badge color={'success'}>Success</Badge>
                                    </>) : (<>
                                        <Badge color={'warning'}>Pending</Badge>
                                    </>)}
                                </td>
                            </tr>
                            <tr>
                                <th>CRM Sync</th>
                                <td className="text-right pr-5">
                                    {data?.crmSync ? (<>
                                        <Badge color={'success'}>Success</Badge>
                                    </>) : (<>
                                        <Badge color={'warning'}>Pending</Badge>
                                    </>)}
                                </td>
                            </tr>
                            <tr>
                                <th>Status</th>
                                <td className="text-right pr-5">
                                    {data?.status ? (<>
                                        <Badge color={'success'}>{data?.status}</Badge>
                                    </>) : (<></>)}
                                </td>
                            </tr>
                            <tr>
                                <th>Payment Information</th>
                                <td className="text-right pr-5">
                                    {data?.payment_by ? data?.payment_by : '-'}
                                </td>
                            </tr>
                        </tbody>
                    </Table>
                </Col>
            </Row>
        </Fragment>
    );
};

export default JourneyDetails;